<div class="table-container">
  <div class="table-scroller" [style.height]="table.tableHeight$ | async">

    @if (table.busy$ | async) {
      <div class="spinner-container">
        <mat-spinner style="margin: 0 auto;"></mat-spinner>
      </div>
    }

    @if (table.empty$ | async) {
        <div class="spinner-container">
            <div class="flex flex-col gap-2 items-center">
                <app-icon icon="truck-empty" class="large"></app-icon>
                <div i18n>No shipments to display</div>
            </div>
        </div>
    }

    <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort matSortDisableClear [matSortActive]="table.sortColumn$ | async" [matSortDirection]="table.sortDirection$ | async" (matSortChange)="table.sortChange($event)">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef style="width: 70px;">
          <mat-checkbox
            (change)="$event ? table.toggleAll() : null"
            [checked]="table.selectionAny$ | async"
          [indeterminate]="table.selectionIndeterminate$ | async"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" style="width: 70px;">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? table.toggle(row.id) : null"
            [disabled]="(busyIds$ | async).indexOf(row.id) > -1"
          [checked]="(table.selection$ | async).indexOf(row.id) !== -1"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="id" style="flex: 0 0 120px;">Number</th>
        <td mat-cell *matCellDef="let shipment" style="width: 120px;">
          <div>
            <div>
              <button mat-button color="primary" [routerLink]="['/shipment', shipment.id ]" (click)="$event.stopPropagation()">{{ shipment.number }}</button>
            </div>
          </div>
        </td>
      </ng-container>

      @for (column of table.columnDefinitions; track column) {
        <ng-container [matColumnDef]="column.id">
            @if (column.id === 'SHIPMENT_STATUS') {
                <th mat-header-cell *matHeaderCellDef [style.width.px]="column.width">
                    <a mat-button [matMenuTriggerFor]="statusFilterMenu" >{{ column.caption }}</a>
                    <mat-menu #statusFilterMenu>
                        <button mat-menu-item (click)="statusFilter(shipmentStates.PREPARING)">Preparing</button>
                        <button mat-menu-item (click)="statusFilter(shipmentStates.QUOTED)">Quoted</button>
                        <button mat-menu-item (click)="statusFilter(shipmentStates.MANIFESTED)">Manifested</button>
                        <button mat-menu-item (click)="statusFilter(shipmentStates.IN_TRANSIT)">In-Transit</button>
                        <button mat-menu-item (click)="statusFilter(shipmentStates.DELIVERED)">Delivered</button>
                        <button mat-menu-item (click)="statusFilter(shipmentStates.VOID)">Void</button>
                        <button mat-menu-item (click)="statusFilter(shipmentStates.EXCEPTION)">Exception</button>
                    </mat-menu>
                </th>
                <td mat-cell *matCellDef="let shipment" style="white-space: nowrap" [style.width.px]="column.width">
                        <app-shipment-indicator
                                [id]="shipment.id" [defaultState]="shipment.status"></app-shipment-indicator>
                </td>
            } @else if (column.id === 'COURIER') {
                <th mat-header-cell *matHeaderCellDef [style.width.px]="column.width">{{ column.caption }}</th>
                <td mat-cell *matCellDef="let shipment" style="white-space: nowrap" [style.width.px]="column.width">
                    <app-courier-logo size="table" [serviceLogo]="shipment.serviceLogo"></app-courier-logo>
                </td>
            } @else {
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column.sort" [disabled]="!column.sort" [start]="column.defaultSortDirection ?? 'asc'" [style.width.px]="column.width">
                    {{ column.caption }}
                </th>
                <td mat-cell *matCellDef="let shipment" style="white-space: nowrap" [style.width.px]="column.width">
                    <span [class]="table.cellClasses(column, shipment)">{{ table.renderCell(column, shipment) }}</span>
                </td>
            }
        </ng-container>
      }

      <ng-container matColumnDef="focus">
        <th mat-header-cell *matHeaderCellDef style="flex: 0 0 70px;">
            @if (displayConfigureMenu$ | async) {
                <button mat-icon-button [matMenuTriggerFor]="configureMenu">
                    <app-icon icon="cog"></app-icon>
                </button>
                <mat-menu #configureMenu>
                    @if (canSaveView$ | async) {
                        <button mat-menu-item (click)="createView()" i18n>Save This View</button>
                    }
                    @if (canDeleteView$ | async) {
                        <button mat-menu-item (click)="deleteView()" i18n>Delete This View</button>
                    }
                    <button mat-menu-item (click)="configureColumns()" i18n>Select Columns</button>
                </mat-menu>
            }
        </th>
        <td mat-cell *matCellDef="let shipment" class="focus-indicator" style="flex: 0 0 60px;">
          @if (focus.isSelected(shipment.id)) {
            <app-icon icon="angle-up"></app-icon>
          }
          @if (!focus.isSelected(shipment.id)) {
            <app-icon icon="angle-down"></app-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="shipment">
        <td mat-cell *matCellDef="let shipment" [attr.colspan]="(displayColumns$ | async).length">
          @if (focus.isSelected(shipment.id)) {
            <div class="summary-container">
              <app-shipment-preparation-summary [shipmentId]="shipment.id"></app-shipment-preparation-summary>
            </div>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="table.displayColumns$ | async; sticky: true" [style.min-width]="table.minRowWidth$ | async"></tr>

      <tr mat-row *matRowDef="let row; columns: table.displayColumns$ | async" (click)="focus.toggle(row.id)" class="main-row cells" [class.processing]="(busyIds$ | async).indexOf(row.id) > -1" [style.min-width]="table.minRowWidth$ | async"></tr>
      <tr mat-row *matRowDef="let shipment; columns: ['shipment']" class="" [@detailExpand]="focus.isSelected(shipment.id) ? 'expanded' : 'collapsed'" [style.min-width]="table.minRowWidth$ | async"></tr>

    </table>
  </div>

  <div class="table-footer">
    @if (table.selectionAny$ | async) {
      <div class="selection-buttons">
        @if (selectionButtonDisplay$ | async) {
          <button mat-raised-button color="primary" (click)="selection()">
            <span i18n>SELECTION</span>
            @if ((table.selection$ | async).length > 1) {
              <span class="button-counter">
                {{ (table.selection$ | async).length }}
              </span>
            }
          </button>
        }
        @if (quoteButton$ | async) {
          <button mat-raised-button color="primary" (click)="quote()">
            <span i18n>QUOTE</span>
            @if ((selectedQuotableCount$ | async) > 1) {
              <span class="button-counter">
                {{ selectedQuotableCount$ | async }}
              </span>
            }
          </button>
        }
        @if (printButton$ | async) {
          <button mat-raised-button color="primary" (click)="printWaybills()" [disabled]="documentsBusy$ | async">
            <span i18n>PRINT WAYBILLS</span>
            @if ((selectedPrintableCount$ | async) > 1) {
              <span class="button-counter">
                {{ selectedPrintableCount$ | async }}
              </span>
            }
          </button>
        }
        @if (voidButton$ | async) {
          <button mat-raised-button color="primary" (click)="voidShipment()">
            <span i18n>VOID</span>
            @if ((selectedVoidableCount$ | async) > 1) {
              <span class="button-counter">
                {{ selectedVoidableCount$ | async }}
              </span>
            }
          </button>
        }
        @if (shipButton$ | async) {
          <button mat-raised-button color="primary" (click)="ship()">
            <span i18n>SHIP</span>
            @if ((selectedShippableCount$ | async) > 1) {
              <span class="button-counter">
                {{ selectedShippableCount$ | async }}
              </span>
            }
          </button>
        }
        @if (pickupButton$ | async) {
          <button mat-raised-button color="primary" (click)="pickup()">
            <span i18n>PICKUP</span>
            @if ((selectedPickupCount$ | async) > 1) {
              <span class="button-counter">
                {{ selectedPickupCount$ | async }}
              </span>
            }
          </button>
        }
      </div>
    }
    <mat-paginator
      [pageIndex]="table.currentPageNumber$ | async"
      [length]="table.totalCount$ | async"
      [pageSize]="25"
      [pageSizeOptions]="[10,25,50,100,200]"
      [showFirstLastButtons]="table.showFirstLast$ | async"
      [hidePageSize]="table.hidePageSize$ | async"
      (page)="table.pageChange($event)"
      >
    </mat-paginator>
  </div>
</div>
